<template>
  <div class="">
    <i class="bi bi-gear h6" data-toggle="modal" data-target="#router-setting-manager"></i>


    <teleport to="body">
      <div class="modal fade" id="router-setting-manager" tabindex="-1"  aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h5 class="text-left">{{ getSiteSelectedLanguage }} - {{ getSiteSelectedPage }}</h5>
            </div>
            <div class="modal-body">

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="routePanels.panels" value="*"
                       id="all-users">
                <label class="custom-control-label" for="all-users">همه ی کاربران</label>
              </div>


              <div class="custom-control custom-checkbox" v-for="panel in routePanelManager">
                <input type="checkbox" v-model="routePanels.panels" :value="panel.slug" class="custom-control-input"
                       :id="`panel-name-${panel.id}`">
                <label class="custom-control-label" :for="`panel-name-${panel.id}`">{{ panel.name }}</label>
              </div>


            </div>
          </div>
        </div>
      </div>
    </teleport>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {guardsObject} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Loan";

export default {
  name: "RouterSetting",
  computed: {
    ...mapGetters({
      getSite: "Site/getSite",
      getSiteSelectedLanguage: "Site/getSiteSelectedLanguage",
      getSiteSelectedPage: "Site/getSiteSelectedPage",
      getPanels: 'Language/getPanels',
    }),
    routePanels() {
      return this.getSite[this.getSiteSelectedLanguage]['pages'][this.getSiteSelectedPage]['routeConfig']
    },
    guardList() {

      return Object.keys(guardsObject()).map(item => {

        let guardName = `G-${item}`

            return {
              "id": this.hashGenerator(),
              "name": guardName,
              "type": 'Guard',
              "slug": guardName,
            }

          }
      )

    },
    routePanelManager() {
      return {...this.getPanels, ...this.guardList}
    }
  },
  methods: {
    hashGenerator() {
      return generateHash()
    }
  }
}
</script>


<style scoped>

</style>